// For connections that need to be associated with a certain key
// e.g., cards for a deck are associated with a deck via the deck's ID:
// { [deckId] => connectionId }
enum RelayKeyedConnection {
  CardsForDeckUrlTitle = "CardsForDeckUrlTitle",
  CardsToStudyForDeckUrlTitle = "CardsToStudyForDeckUrlTitle",
}

export default RelayKeyedConnection;
